import * as React from 'react';
import withStyles from 'react-jss';
import * as lodash from 'lodash';

import DetailsCard from './DetailsCard';
import NewPieceDetailsTab from '@components/pages/details/NewPieceDetailsTab';
import ConsignmentLogTab from '@components/pages/details/ConsignmentLogTab';
import ChatComponent from '@components/pages/details/ChatComponent';
import * as moment from 'moment';
import { getColumnsForSupplementaryServices } from '../supplementaryServicesColumns';
import { CssType, ThemeType } from '@theming/jssTypes';
import { SwitchMapListView } from '@components/common/SwitchMapListView';
import { formatDateTime, downloadFileData } from '@utils/utils';
import {
  defaultState,
  CustomActionsBarReducer,
} from '@components/pages/GenericConsignment/CustomActionBar/CustomActionBarReducer';
import { SettingIcon } from '@components/common/icons/SettingsIcon';
import GalleryModal from 'src/design-system/components/molecules/GalleryModal/GalleryModal';
import GalleryModalWithSignedUrl from '@components/common/GalleryModalWithSignedUrl';
import CustomColumnsModal from '@components/pages/dashboard/CustomColumnsModalWithViewType';

import NestedCustomColumnsModal from 'src/design-system/components/organisms/NestedCustomColumnsModal/NestedCustomColumnsModal';
import { Link } from 'react-router-dom';
import { Tabs, Image, Tooltip, Button, message, Select, Modal, Carousel } from 'src/design-system/components/atoms';
import { downloadRiderEvents, fetchSignedUrlOfCallRecording } from '@src/api/dashboard';
import { LeftCircleOutlined, RightCircleOutlined, DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { WarningFilled, SoundFilled } from '@ant-design/icons';
import { getRetailTripDetailsRoute } from '@routing/utils';
import { tablePaginationStyle } from '@theming/cssSnippets/commonSnippets';
import { isBoolean, isValidUrl } from '@utils/utils';
import ClaimRequestsTable from '@components/common/ClaimProcessManagement/ClaimRequestsTable';
import TimelineWithStops from '../TimelineWithTabs/TimelineWithStopsModal';
import GenericTabsWithSummaryMetric from 'src/design-system/components/molecules/GenericTabsWithSummaryMetric/GenericTabsWithSummaryMetric';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';
import { ellipsisWithTooltip } from '../utils';
import { useTranslation } from 'react-i18next';
import { getSignedUrlApi } from '@api/getSignedUrl';
import QcDetails from './QcDetails';
import SupportTicketsTable from 'src/components/pages/SupportTickets/SupportTicketsTable';
import InvoiceDetailsTable from '@components/common/ConsignmentInvoices/InvoiceDetails';
import { connect } from 'react-redux';
import SimplePaginator from 'src/design-system/components/molecules/SimplePaginator/SimplePaginator';
import { useTheme } from 'src/theming/useTheme';
import QCChecklistComponent from '@components/common/QuestionnaireModal';
interface GalleryModalData {
  videos: string[];
}

const styles = (theme: ThemeType): CssType => ({
  tabsCardsContainer: {
    backgroundColor: theme.color.semantic.background.neutral.primary,
    borderRadius: theme.radius.sm,
    padding: theme.spacing[0],
    overflow: 'scroll',
    height: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  tabsContainer: {
    boxSizing: 'border-box',
    backgroundColor: theme.color.semantic.background.neutral.primary,
    borderRadius: theme.radius.md,
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
    '& .ant-tabs-nav-list': {
      padding: '0.33% 0 0.33% 2%',
    },
    '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
      color: `${theme.color.semantic.brand.default.primary} !important`,
    },
    '& .ant-tabs-ink-bar': {
      position: 'absolute',
      background: theme.color.semantic.brand.default.primary,
    },
    '& .ant-tabs-content': {
      height: '100% !important',
    },
    '& .ant-tabs-content-holder': {
      height: '100%',
    },
    margin: '1% 0.5%',
    boxShadow: theme.shadow.sm,
    height: '93%',
    overflowY: 'scroll',
  },
  borderlessTabContainer: {
    backgroundColor: theme.color.semantic.background.neutral.primary,
    flex: 1,
    order: 0,
    alignSelf: 'stretch',
    // flexGrow: 1,
    '& .ant-tabs-nav-list': {
      padding: '0.33% 0 0.33% 2%',
    },
    '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
      color: `${theme.color.semantic.brand.default.primary} !important`,
    },
    '& .ant-tabs-ink-bar': {
      position: 'absolute',
      background: theme.color.semantic.brand.default.primary,
    },
  },
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    margin: `${theme.spacing[0]} ${theme.spacing[4]} ${theme.spacing[4]} ${theme.spacing[4]}`,
    boxShadow: theme.shadow.sm,
    '& tr': {
      verticalAlign: 'top',
    },
    '& th': {
      verticalAlign: 'middle',
    },
    ...tablePaginationStyle(),
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: `${theme.spacing[4]} ${theme.spacing[2]}`,
    },
  },
  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing[2],
    padding: `${theme.spacing[3]} ${theme.spacing[4]}`,
    backgroundColor: theme.color.semantic.background.neutral.secondary,
    border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
    borderTop: 'none',
    borderRadius: `${theme.spacing[0]} ${theme.spacing[0]} ${theme.radius.sm} ${theme.radius.sm}`,
    position: 'relative',
    zIndex: 1000,
    '& .ant-select': {
      zIndex: 1000,
      '& .ant-select-dropdown': {
        zIndex: 1000,
      },
    },
  },
  pageSizeSelector: {
    minWidth: '100px',
    '& .ant-select-selector': {
      height: theme.spacing[8],
      display: 'flex',
      alignItems: 'center',
    },
    '& .ant-select-dropdown': {
      zIndex: '1000 !important',
    },
  },
  settingsIcon: {
    display: 'flex',
    color: theme.color.semantic.text.primary,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    margin: `${theme.spacing[0]} ${theme.spacing[4]}`,
  },
  btn: {
    color: theme.color.semantic.brand.default.secondary,
    cursor: 'default',
  },
  carouselContainer: {
    padding: theme.spacing[3],
    maxWidth: '100%',
    '& span': {
      color: `${theme.color.semantic.text.primary} !important`,
    },
    '& span > svg': {
      width: '120%',
      height: '120%',
    },
  },
  buttonBar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  setFontSize: {
    fontSize: theme.typography.fontSize.lg,
  },
  warningFilledStyle: {
    fontSize: theme.typography.fontSize.lg,
    color: theme.color.semantic.accent.orange.strong,
    marginLeft: theme.spacing[2],
  },
});

const QC_TABLE_COLUMN = [
  {
    title: 'Parameter',
    dataIndex: 'param',
    key: 'param',
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
  },
];

const PRIMARY_TRIP = 'primary';

const TabSection = (props: any) => {
  const TabPane = Tabs.TabPane;
  const {
    classes,
    data,
    executionStatusList,
    callLogsData,
    reload,
    isMapView,
    handleMapListViewChange,
    metadata,
    currentActiveTab,
    handleCurrentActiveTab,
    handleCustomColumnModalSubmit,
    columnList,
    taskColumnList,
    trackingColumnList,
    actionList,
    showPickupTaskTab,
    getPropsByHeader = () => {},
    getCustomDetailsCard,
    headerList,
    fullHeadersList,
    isSuperAdmin,
    activeUpdatesList,
    updatesList,
    autoRefreshTrip,
    objectType,
    passNestedFields,
    handleRefresh,
    getPaginationConfig,
    renderSearchBox,
  } = props;
  const activeTab = new URLSearchParams(window.location.search).get(
    'activeTab',
  );

  const { t } = useTranslation();
  let tabs = props.tabs;
  tabs = tabs.filter(tab => tab.tab_header !== 'Deleted Piece Details' || data?.deleted_child_consignments?.length > 0);

  const [visible, setVisible] = React.useState(false);
  const [imageData, setImageData] = React.useState(null);

  const [showCustomColumnModal, setShowCustomColumnModal] =
    React.useState(false);
  const [isImageVideoModalVisible, setIsImageVideoModalVisible] =
    React.useState(false);
  const [isQCTableVisible, setIsQCTableVisible] = React.useState(false);
  const [isGalleryModalVisible, setIsGalleryModalVisible] = React.useState(false);
  const [galleryModalData, setGalleryModalData] =
    React.useState<GalleryModalData>({ videos: [] });
  const [mediaList, setMediaList] = React.useState([]);
  const [qcData, setQCData] = React.useState([]);
  const [imageVideoGalleryData, setImageVideoGalleryData] = React.useState({
    images: [],
    videos: [],
  });
  const [isCallRecordingLoading, setIsCallRecordingLoading] = React.useState(false);
  const [isChecklistSummaryVisible, setIsChecklistSummaryVisible] = React.useState(false);
  const [checklistSummaryData, setChecklistSummaryData] = React.useState<{ qcOutput: any[]; qcStatus?: string } | null>(null);
  const theme = useTheme();

  const renderTab = (tab: any) => {
    switch (tab.type) {
      case 'table':
        return tableView(
          tab.tab_header,
          tab?.details[0]?.columns,
          tab.actions_to_show,
          tab.tab_headers_to_show,
        );
      case 'trip_logs_with_timeline':
        return tripLogsWithTimeline(tab.tab_header, tab.details);
      case 'claim_requests':
        return claimRequestsTableView(tab.tab_header, tab.details);
      case 'timeline':
        return timelineView(tab.tab_header, tab.details);
      case 'chat':
          return chatView(tab.tab_header, tab.details);
      case 'support_tickets':
        return supportTicketsTableView(tab?.details?.[0]?.columns);
      case 'invoice_details':
        return invoiceDetailsTableView(tab.tab_header, tab.details);
      default:
        return defaultView(tab.tab_header, tab.details);
    }
  };
  const renderGalleryModal = (imageArray: any[], videoArray: any[]) => {
    if (!imageArray || !videoArray) return t('not available');
    return (
      <a onClick={() => {
        setGalleryModalData({
          videos: videoArray,
        });
        setMediaList(imageArray);
        setIsGalleryModalVisible(true);
      }}
      >
        View
      </a>
    );
  };

  const customModalSubmit = (columns, actions, headers, updates) => {
    const newUpdates = {};
    newUpdates[currentActiveTab] = updates;
    if (autoRefreshTrip) {
      autoRefreshTrip(updates);
    }
    return handleCustomColumnModalSubmit(columns, actions, headers, newUpdates);
  };

  const getPropValueForTab = (
    currentActiveTab: string, 
    propName: string,
    defaultValue: any
  ) => {
    switch (currentActiveTab) {
      case 'Consignment Details':
        switch (propName) {
          case 'fullColumnList':
            return fullHeadersList;
          case 'hideColumnTab':
            return true;
          case 'hideActions':
            return true;
          case 'allowMainDashboardSwitch':
            return false;
          case 'showHeaders':
            return true;
          default:
            return defaultValue;
        }
      case 'Tasks':
      case 'Consignments':
      case 'Trip Tracking':
        switch (propName) {
          case 'hideColumnTab':
            return false;
          default:
            return defaultValue;
        }
      default:
        return defaultValue;
    }  
  };

  const getColumnsToShow = () => {
    const columnsToShow = columnList || [];
    const taskColumnsToShow = taskColumnList;
    const trackingColumnsToShow = trackingColumnList || [];
    
    switch (currentActiveTab) {
      case 'Tasks':
        return taskColumnsToShow;
      case 'Trip Tracking':
        return trackingColumnsToShow;
      default:
        return columnsToShow;
    }
  };

  const renderActionsByTabHeader = () => {
    const columnsToShow = columnList || [];
    const taskColumnsToShow = taskColumnList;

    const defaultMetadata = metadata?.tabs_to_show?.filter((tab) => {
      return tab.tab_header === currentActiveTab;
    });
    const fullColumnList = lodash.get(
      defaultMetadata?.[0],
      'details[0].columns',
      [],
    );
    const fullActionsList = metadata?.actions_to_show;

    const customColumnModalProps = {
      isVisible: showCustomColumnModal,
      onModalClose: () => setShowCustomColumnModal(false),
      onModalSubmit: customModalSubmit,
      showFiltersAndActions: true,
      defaultTab: "column",
      currentActiveTab: currentActiveTab,
      columnsToShow: getColumnsToShow(),
      fullColumnList: getPropValueForTab(currentActiveTab, 'fullColumnList', fullColumnList),
      actionsToShow: actionList,
      fullActionsList: fullActionsList,
      activeUpdatesList: activeUpdatesList,
      hideColumnTab: getPropValueForTab(currentActiveTab, 'hideColumnTab', true),
      updatesList: updatesList,
      fullHeadersList: fullHeadersList,
      headersToShow: headerList,
      hideFilters: true,
      hideActions: getPropValueForTab(currentActiveTab, 'hideActions', false),
      showHeaders: getPropValueForTab(currentActiveTab, 'showHeaders', isSuperAdmin),
      handleRefresh: handleRefresh,
      allowMainDashboardSwitch: getPropValueForTab(currentActiveTab, 'allowMainDashboardSwitch', true),
      passNestedFields: passNestedFields
    };
    const customModal = (
      <div>
        <a className={classes.settingsIcon}>
          {handleCustomColumnModalSubmit && currentActiveTab!=='Consignment Details' && (
            <SettingIcon
              className={classes.setFontSize}
              onClick={() => setShowCustomColumnModal(!showCustomColumnModal)}
            />
          )}
        </a>
        {showCustomColumnModal && (
          passNestedFields ? (
            <NestedCustomColumnsModal {...customColumnModalProps} />
          ) : (
            <CustomColumnsModal
              {...customColumnModalProps}
            />
          )
        )}
      </div>
    );

    const paginationComponent = (() => {
      if(getPaginationConfig){
        const paginationConfig = getPaginationConfig(currentActiveTab);
        if(paginationConfig){
          const { current, total, pageSize, pageSizeOptions, onChange, onShowSizeChange, totalText } =
            paginationConfig;
          const totalPages = Math.ceil(total / pageSize);
          const isNext = current < totalPages;
          return (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing[2],
              position: 'relative',
              zIndex: 1000,
            }}>
              <SimplePaginator
                pageNumber={current}
                isNext={isNext}
                onFirstClick={() => onChange(1, pageSize)}
                onPrevClick={() => onChange(current - 1, pageSize)}
                onNextClick={() => onChange(current + 1, pageSize)}
              />
              <Select
                className={classes.pageSizeSelector}
                value={pageSize}
                onChange={onShowSizeChange}
                getPopupContainer={() => document.body}
                dropdownStyle={{ zIndex: 1000 }}
              >
                {pageSizeOptions.map(option => (
                  <Select.Option key={option} value={parseInt(option, 10)}>
                    {option} / page
                  </Select.Option>
                ))}
              </Select>
              <Tooltip title={`Total ${currentActiveTab} ${totalText}`}>
                <span style={{ fontSize: theme.typography.fontSize.sm }}>
                  {totalText}
                </span>
              </Tooltip>
            </div>
          );
        }
      }
      return null;
    })();

    switch (currentActiveTab) {
      case 'Consignments':
      case 'Tasks':
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing[2] }}>
            {renderSearchBox && renderSearchBox()}
            {paginationComponent}
            <SwitchMapListView
              isMapView={isMapView}
              onChange={handleMapListViewChange}
            />
            {customModal}
          </div>
        );
      default:
        return <div style={{ display: 'flex', alignItems: 'center', gap: theme.spacing[2] }}>
          {customModal}
        </div>;
    }
  };

  const downloadCNRiderEvents = async () => {
    const body = {
      referenceNumber: data?.reference_number,
    };
    const response: any = await downloadRiderEvents(body);
    if (response.isSuccess) {
      downloadFileData(response.data, 'rider_events', '.xlsx');
    } else {
      message.error(response.errorMessage);
    }
  };

  const generateActionButtons = (actions) => {
    const actionButtons = [];
    if (Array.isArray(actions) && actions.length) {
      actions.forEach((action) => {
        switch (action.key) {
          case 'download_rider_events':
            actionButtons.push(
              <Button onClick={downloadCNRiderEvents}>
                <DownloadOutlined />
              </Button>,
            );
            break;
        }
      });
    }
    return actionButtons;
  };

  const tableView = (tab_header, columns, actions_to_show, tab_headers_to_show) => {
    let tabPane;
    if (tab_header === 'Piece Details') {
      tabPane = (
        <>
          <div className={classes.borderlessTabContainer}>
            <NewPieceDetailsTab
              data={data?.pieces_detail}
              pieceDetails={{
                pieceDetailsData: data?.pieces_detail,
              }}
              columns={columns}
              reload={reload}
              cnReferenceNumber={data?.reference_number}
              bucket={'consignment_piece_details'}
            />
          </div>
        </>
      );
    } else if (tab_header === 'Deleted Piece Details') {
      tabPane = (
        <>
          <div className={classes.borderlessTabContainer}>
            <NewPieceDetailsTab
              data={data?.deleted_child_consignments}
              pieceDetails={{
                pieceDetailsData: data?.deleted_child_consignments,
              }}
              columns={columns}
              reload={reload}
              cnReferenceNumber={data?.reference_number}
              deletedPieces={true}
            />
          </div>
        </>
      );
    } else if (tab_header === 'QC Details') {
      tabPane = (
        <>
          <QcDetails
            referenceNumber={data?.reference_number}
            qcHeaders={tab_headers_to_show}
            qcTableColumns={columns}
          />
        </>
      );
    } else if (tab_header === 'Customer Profile') {
      tabPane = (
        <>
          <QcDetails
            referenceNumber={data?.reference_number}
            qcHeaders={tab_headers_to_show}
            qcTableColumns={columns}
            apiEndpoint="customer_feedback"
          />
        </>
      );
    } else {
      tabPane = (
        <>
          <div className={classes.tabsCardsContainer}>
            <div className={classes.buttonBar}>
              {generateActionButtons(actions_to_show)}
            </div>
            <FixedHeaderTable
              locale={{ emptyText: t('No data found') }}
              dataSource={getDataSourceByTabHeader(tab_header)}
              pagination={false}
              columns={tab_header !== 'Supplementary Services' ? getColumnsForTable(columns, tab_header): getColumnsForSupplementaryServices(columns)}
              key={tab_header}
              {...getPropsByHeader(tab_header)}
            />
          </div>
        </>
      );
    }

    return tabPane;
  };

  const getDataSourceByTabHeader = (data_header) => {
    switch (data_header) {
      case 'Tracking':
      case 'CN Tracking':
      case 'Consignment Log':
        return data?.events;
      case 'Rider Events':
        return data?.rider_events;
      case 'Job Tracking':
        return data?.job_events;
      case 'Supplementary Services':
        return data?.supplementary_services;
      case 'Item Details':
        return data?.items_detail;
      case 'Call Logs':
        return callLogsData;
      case 'HU Details':
        return data?.hu_details;
      case 'Bag Details':
        const bagDetails = data?.returnable_assets_details;
        if (!bagDetails) return [];
        
        const assetArray = Array.isArray(bagDetails)
          ? bagDetails
          : (Array.isArray(bagDetails?.asset_details) ? bagDetails.asset_details : []);
        
        return assetArray.map((asset, index) => ({
          ...asset,
          asset_reference_number: asset.reference_number || asset.asset_reference_number || '',
          key: asset.reference_number || `bag-${index}`
        }));
      default:
        return data;
    }
  };

  const getDefaultViewDataByHeader = (tab_header) => {
    switch (tab_header) {
      case 'Trip Details':
        return data?.tripDetails;
      default:
        return data;
    }
  };

  const defaultView = (tab_header, details) => {
    return (
      <>
        {tab_header === 'Consignment Details' && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <SettingIcon
              className={classes.setFontSize}
              onClick={() => setShowCustomColumnModal(!showCustomColumnModal)}
              style={{ marginRight: theme.spacing[5], paddingBottom: theme.spacing[1], paddingTop: theme.spacing[1] }}
            />
          </div>
        )}
        <div className={classes.tabsCardsContainer}>
          {details?.map((card) => {
            return (
              <DetailsCard
                key={card.header}
                title={card.header}
                data={getDefaultViewDataByHeader(tab_header)}
                columns={card.columns}
                getCustomDetailsCard={getCustomDetailsCard}
                objectType={objectType}
              />
            );
          })}
        </div>
        <div>
          <div style={{ display: 'none' }}>
            <Image.PreviewGroup
              preview={{
                visible,
                onVisibleChange: (vis) => setImage(),
              }}
            >
              {Array.isArray(imageData) ? (
                imageData?.map((url) => <Image src={url} placeholder={true} />)
              ) : (
                <Image src={imageData} placeholder={true} />
              )}
            </Image.PreviewGroup>
          </div>
        </div>
        <div>
          {isQCTableVisible && (
            <Modal
              title={'QC Parameters'}
              className={classes.modalContainer}
              visible={isQCTableVisible}
              onCancel={() => setIsQCTableVisible(false)}
              footer={null}
              style={{ height: 'calc(100vh - 200px)' }}
              width={'400px'}
            >
              <Carousel
                className={classes.carouselContainer}
                prevArrow={<LeftCircleOutlined />}
                nextArrow={<RightCircleOutlined />}
                arrows
              >
                {qcData.map((qcRow, index) => (
                  <div>
                    <div className={classes.tableContainer}>
                      <p style={{ textAlign: 'center' }}>
                        Item {index + 1}
                        <br />
                      </p>
                      <FixedHeaderTable
                        locale={{ emptyText: 'No data found' }}
                        dataSource={qcRow}
                        pagination={false}
                        scroll={{ y: 420 }}
                        columns={QC_TABLE_COLUMN}
                      />
                    </div>
                  </div>
                ))}
              </Carousel>
            </Modal>
          )}
        </div>
      </>
    );
  };

  const timelineView = (tab_header, details) => {
    return (
      <>
        <div className={classes.borderlessTabContainer}>
          <ConsignmentLogTab
            events={data?.events}
            data={data}
            details={details}
          />
        </div>
      </>
    );
  };

  const chatView = (tab_header, details) => {
    return (
        <ChatComponent details={details} tripId={data?.tripDetails?.id}/>
    );
  };
  const tripLogsWithTimeline = (tab_header, details) => {
    return (
      <>
        <div className={classes.borderlessTabContainer}>
          <TimelineWithStops
            events={data?.events}
            data={data}
            details={details}
          />
        </div>
      </>
    );
  };
  const claimRequestsTableView = (tab_header, details) => {
    return (
      <ClaimRequestsTable
        consignmentReferenceNumber={data?.reference_number}
      />);
  };

  const supportTicketsTableView = (columns) => {
    return (
      <SupportTicketsTable
        columnsToShow={columns}
        tripReferenceNumber={data?.tripDetails?.trip_reference_number}
        referenceNumber={data?.reference_number}
      />);
  };

  const invoiceDetailsTableView = (tab_header, details) => {
    return (
      <InvoiceDetailsTable
        consignmentId={data?.id}
        referenceNumber={data?.reference_number}
        parentReferenceNumber={data?.parent_reference_number}
      />
    );
  };

  const setImage = (data = null) => {
    setVisible(!visible);
    setImageData(data);
  };

  const renderImage = (data) => {
    if (!data) return t('No Data');
    return (
      <span onClick={() => setImage(data)}>
        <a>{t('View')}</a>
      </span>
    );
  };

  const generateAnchorLink = (data) => {
    const entry = [];
    data?.forEach((link) =>
      entry.push(
        <a href={link} target={'_blank'}>
          {t('Click Here')}<br></br>
        </a>,
      ),
    );
    return entry;
  };

  const displayQCData = (data) => {
    const tableData = [];
    data?.forEach((entry) => {
      const displayData = [];
      entry?.forEach((value) =>
        displayData.push({
          param: value[0],
          value: value[1]?.toString(),
        }),
      );
      tableData.push(displayData);
    });
    setQCData(tableData);
    setIsQCTableVisible(true);
  };

  const generateActionData = (type, data) => {
    if (type.startsWith('QC')) {
      return <a onClick={() => displayQCData(data)}>Click Here</a>;
    }
    switch (type) {
      case 'OTP Generated':
      case 'OTP Verified':
        return isBoolean(data) ? data?.toString() : t('not available');
      case 'Call Recording':
      case 'Image':
        const images = data?.images || [];
        const videos = data?.videos || [];
        if(!images.length && !videos.length) return t('not available');
        return renderGalleryModal(images, videos);
      default:
        return data;
    }
  };

  const toggleImageVideoGallery = (images, videos) => {
    setIsImageVideoModalVisible(!isImageVideoModalVisible);
    setImageVideoGalleryData({
      images,
      videos,
    });
  };

  const renderImageVideoGallery = (imageArray, videoArray) => {
    return (
      <>
        <div
          onClick={() => {
            toggleImageVideoGallery(imageArray, videoArray);
          }}
          className={classes.btn}
        >
          View
        </div>
      </>
    );
  };

  const openCallRecordingWithSignedUrl = ({ record, publicUrl }) => {

    const fetchSignedUrl = async () => {
    let url = publicUrl;
      try {
        setIsCallRecordingLoading(true);
        if (record.toFetchSignedUrl) {
          const response = await fetchSignedUrlOfCallRecording(record.id);
          if (!response?.isSuccess || !response?.data?.url) {
            throw new Error(response?.error?.message || 'Failed to fetch call Recording');
          }
          url = response?.data?.url;
        }
        window.open(url, '_self');
      } catch (error) {
        message.error(error.message || 'Failed to fetch call Recording');
      } finally {
        setIsCallRecordingLoading(false);
      }
    };
    
    return (
      <span>
        <a onClick={fetchSignedUrl}>
          Click Here
        </a>
        {isCallRecordingLoading && <LoadingOutlined style={{ marginLeft: 8 }} />}
      </span>
    );
  };

  const getColumnsForTable = (columnsToShow, tab_header) => {
    // const { showThirdParty } = this.props;
    // const columnsToShow = getColumnsToShowCNDetailsTracking(showThirdParty);

    const widthMap = {
      s_no: 50,
      event_string: 120,
      event_time: 140,
    };
    const columns = columnsToShow?.map((col) => {
      return (
        col && {
          dataIndex: col.id,
          title: t(col.pretty_name),
          width: widthMap[col.id] ?? 80,
          render: (x, record, index) => {
            switch (col.key) {
              case 'event_string':
                return (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {ellipsisWithTooltip(x)}
                    {record.is_partial_delivery ? (
                      <Tooltip title={t('Partially Delivered')}>
                        <WarningFilled
                          className={classes.warningFilledStyle}
                        />
                      </Tooltip>
                    ) : record.is_partial_pickedup ? (
                      <Tooltip title={t('Partially Pickedup')}>
                        <WarningFilled
                          className={classes.warningFilledStyle}
                        />
                      </Tooltip>
                    ) : record.is_partial_job ? (
                        <Tooltip title={t('Partially Completed Job')}>
                          <WarningFilled
                            className={classes.warningFilledStyle}
                          />
                        </Tooltip>
                      ) : null}
                  </div>
                );
              case 's_no':
                return <div>{index + 1}</div>;
              case 'event_time':
                return x ? moment(x).format('DD/MM/YYYY, HH:mm') : null;
              case 'execution_status':
                return t(getExecutionStatusPrettyNames(x));
              case 'poa_image':
                return x ? renderImage(x) : null;
              case 'updated_by':
                return record.employee_code
                  ? record.employee_code
                  : record.grab_rider_name
                  ? record.grab_rider_name
                  : record.worker_code
                  ? record.worker_code
                  : '';
              case 'employee':
                return record.employee_username
                  ? `${record.employee_username} (${
                      record.employee_code ? record.employee_code : ''
                    })`
                  : '';
              case 'message':
                return isValidUrl(x) ? openCallRecordingWithSignedUrl({record, publicUrl: x}) : x;
              case 'courier_partner':
                return (
                  <div>
                    <div> {t(x)} </div>
                    {record.courier_account && (
                      <div> {t(record.courier_account)} </div>
                    )}
                  </div>
                );
              case 'geofence_proof_image_list':
                const geofenceImages = record?.geofence_proof_image_list || [];
                const geofenceVideos = record?.geofence_proof_video_list || [];
                if (geofenceImages.length === 0 && geofenceVideos.length === 0) return '';
                return renderGalleryModal(geofenceImages, geofenceVideos);
              case 'event_proof_images':
                const cnImages = record?.event_proof_images || [];
                const cnVideos = record?.event_proof_videos || [];
                const paymentImages = record?.payment_proof_images || [];
                const paymentVideos = record?.payment_proof_videos || [];
                
                // Use tabs mode for CN Tracking page (only show tabs that have content)
                if (tab_header === 'CN Tracking') {
                  const hasPodImages = cnImages.length > 0 || cnVideos.length > 0;
                  const hasPaymentImages = paymentImages.length > 0 || paymentVideos.length > 0;
                  
                  if (!hasPodImages && !hasPaymentImages) return '';
                  
                  // Build tabs array with only tabs that have content
                  const tabsArray = [];
                  if (hasPodImages) {
                    tabsArray.push({
                      label: 'POD Images',
                      imageArray: cnImages,
                      videoArray: cnVideos,
                      toFetchSignedUrl: true,
                    });
                  }
                  if (hasPaymentImages) {
                    tabsArray.push({
                      label: 'Card Transaction Images',
                      imageArray: paymentImages,
                      videoArray: paymentVideos,
                      toFetchSignedUrl: true,
                    });
                  }
                  
                  // If only one tab has content, use tabs mode anyway (component will handle single tab gracefully)
                  return (
                    <GalleryModalWithSignedUrl
                      tabs={tabsArray}
                    />
                  );
                }
                
                // Backward compatible: single modal mode for other pages
                if (cnImages.length === 0 && cnVideos.length === 0) return '';
                return (
                  <GalleryModalWithSignedUrl
                    imageArray={cnImages}
                    videoArray={cnVideos}
                    toFetchSignedUrl={true}
                  />
                );
              case 'job_image_list':
                const jobImages = record?.job_image_list || [];
                const jobVideos = record?.job_video_list || [];
                if (jobImages.length === 0 && jobVideos.length === 0) return '';
                return renderGalleryModal(jobImages, jobVideos);
              case 'pod_image':
              case 'delivery_scan_failure_image':
              case 'pickup_scan_failure_image':
                return renderImage(x);
              case 'arrival_time':
                return formatDateTime(record[col.id]);
              case 'action_details':
                return generateActionData(record.action_type, x);
              case 'trip_id':
                return (
                  <Link
                    to={{
                      pathname: getRetailTripDetailsRoute(x),
                    }}
                    target={'_blank'}
                  >
                    {x}
                  </Link>
                );
              case 'recording_url':
                return x ? (
                  <a
                    href={x}
                    target="_blank"
                    aria-label="URL"
                  >
                    <SoundFilled />
                  </a>
                ) : null;
              case 'otp_generated':
              case 'otp_success':
                if ([
                  'delivered', 'pickup_completed','not_picked_up','attempted',
                  'rto_delivered', 'rvp_delivered',
                ].includes(record.type)) {
                  return x ? t('Yes') : t('No');
                }
                return null;
              case 'geofence_failure_reason':
              case 'notes':
              case 'geofence_failure_reason_id':
                return x;
              case 'is_reconciled':
                return x ? t('Yes') : t('No');
              case 'asset_reference_number':
                return x || record?.reference_number || '';
              case 'exception_code':
                return x || '-';
              case 'delay_reason':
                return x || null;
              case 'first_action_timestamp':
                return x ? moment(x).format('DD/MM/YYYY HH:mm') : null;
              case 'grace_time':
                return x ?? '-';
              case 'event_qc_data':
                const qcSelfData = record?.event_qc_data?.self;
                const qcOutput = qcSelfData?.qc_output;
                console.log('qcOutput', qcOutput);
                if (!qcOutput || !Array.isArray(qcOutput) || qcOutput.length === 0) return null;
                return (
                  <a onClick={() => {
                    setChecklistSummaryData({
                      qcOutput,
                      qcStatus: qcSelfData?.qc_status,
                    });
                    setIsChecklistSummaryVisible(true);
                  }}>
                    {t('View')}
                  </a>
                );
              default:
                return t(x);
            }
          },
        }
      );
    });
    return columns.filter((column) => column);
  };

  const getExecutionStatusPrettyNames = (key) => {
    const obj = executionStatusList?.find((lis) => lis.code === key);
    return obj?.name || null;
  };

  const getTabToRender = (tabHeader, tab) => {
    switch (tabHeader) {
      case 'Consignments':
        return showPickupTaskTab ? null : renderTab(tab);
      case 'Pickup Tasks':
        return showPickupTaskTab ? renderTab(tab) : null;
      case 'Drops':
        return data?.data?.tripDetails?.trip_type !== PRIMARY_TRIP
          ? null
          : renderTab(tab);
      default:
        return renderTab(tab);
    }
  };

  return (
    <>
      <GenericTabsWithSummaryMetric
        tabBarExtraContent={renderActionsByTabHeader()}
        defaultActiveKey={activeTab}
        tabs={
          tabs?.map((tab) => {
            return {
              header: {
                title: t(tab.tab_header),
              },
              key: tab.tab_header,
              Component: getTabToRender(tab.tab_header, tab) ?? <></>,
            };
          })
        }
        onChange={(activeKey) => {
          if (handleCurrentActiveTab) {
            handleCurrentActiveTab(activeKey);
            if (activeKey !== 'Consignments') {
              handleMapListViewChange(false);
            }
          }
        }}
      />
      {isGalleryModalVisible && (
        <GalleryModal
          isVisible={isGalleryModalVisible}
          imageVideoGalleryData={galleryModalData}
          mediaList={mediaList}
          handleModalClose={() => {
            setGalleryModalData({ videos: [] });
            setMediaList([]);
            setIsGalleryModalVisible(false);
          }}
        />
      )}
      {isChecklistSummaryVisible && checklistSummaryData && (
        <QCChecklistComponent
          viewMode
          configData={[]}
          qcOutputData={checklistSummaryData.qcOutput}
          qcStatus={checklistSummaryData.qcStatus}
          onSubmit={() => {}}
          onClose={() => {
            setIsChecklistSummaryVisible(false);
            setChecklistSummaryData(null);
          }}
        />
      )}
    </>
  );
};

export default withStyles(styles, { injectTheme: true })(TabSection);
